import type { FemaOutcomeFieldFinding } from 'types/fema.types';
import { getFemaFindingInput } from '../../../../utils/femaFindingField.utils';

type IpawsBackendFindingsListProps = {
  findings?: FemaOutcomeFieldFinding[];
  /**
   * A different visible label for an input, keyed by its draft field path. The Global Actions
   * editor has no expiration input, so it names the update interval for `expires`.
   */
  inputLabelOverrides?: Record<string, string>;
};

/**
 * The backend's field findings on a refusal (a 400 body: `findings[]` with `field`, `message`
 * and `code`). A finding with a known FEMA code names the form input it is about (card FE-06).
 */
const IpawsBackendFindingsList = ({
  findings,
  inputLabelOverrides = {},
}: IpawsBackendFindingsListProps) =>
  findings?.length ? (
    <ul className="mb-0 mt-2 ps-3">
      {findings.map((finding) => {
        const input = getFemaFindingInput(finding);
        return (
          <li key={`${finding.field}-${finding.code ?? finding.message}`}>
            {input ? (
              <>
                <strong>{inputLabelOverrides[input.fieldPath] ?? input.label}</strong> (FEMA{' '}
                {finding.code}, <code>{finding.field}</code>
                ): {finding.message}
                <small className="d-block">{input.statusRemark}</small>
              </>
            ) : (
              <>
                <code>{finding.field}</code>: {finding.message}
              </>
            )}
          </li>
        );
      })}
    </ul>
  ) : null;

export default IpawsBackendFindingsList;
